import {
    SET_ALL_CUSTOMERS,
    DELETE_CUSTOMER,
    UPDATE_CUSTOMER
  } from './customersAction';
  
  const initialState = {
    allCustomers: [],
  };
  
  export const customersReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_ALL_CUSTOMERS:
        return {
          ...state,
          allCustomers: action.payload,
        };
  
      case DELETE_CUSTOMER:
        return {
          ...state,
          allCustomers: state.allCustomers.filter(
            (customer) => customer.email !== action.payload
          ),
        };
  
      case UPDATE_CUSTOMER:
        return {
          ...state,
          allCustomers: state.allCustomers.map((customer) =>
            customer.email === action.payload.email ? action.payload : customer
          ),
        };
  
      default:
        return state;
    }
  };
  